<template>
  <div class="employee-acknowledgement-list-empty-state text-textLight text-body-2">
    {{ message }}
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: 'No employees match your filters or search. Try adjusting your filters or search term.',
  },
});
</script>

<style lang="less" scoped>
.employee-acknowledgement-list-empty-state {
  padding: 24px 16px;
  text-align: center;
  border-bottom: 1px solid @stroke-default;
}
</style>
